import React, { useEffect, useState } from 'react';
import { TextField } from '@mui/material';
import localforage from 'localforage';
import { useRecoilState, useRecoilValue } from 'recoil';
import {
  mainWindowSizeState
} from '#state';

export function MainWindowSize() {
  const [windowSize, setWindowSize] =
    useRecoilState(mainWindowSizeState);

  useEffect(() => {
    localforage.setItem('mainWindowSizeState', windowSize);
  }, [windowSize]);

  const handleChange = (event) => {
    const newValue = event.target.value;
    const v = parseFloat(newValue)
    if (v >= 1) {
      setWindowSize(v);
    } else {
      setWindowSize(10);
    }
  };

  return (
    <TextField
      sx={{ width: '4rem' }}
      label="M Hours"
      type="number"
      size='small'
      inputProps={{ min: 1 }} // set the minimum value to 1
      value={windowSize}
      onChange={handleChange}
    />
  );
}

export default MainWindowSize;